import { ProtectedRoute } from '@shared/auth';
import { Outlet } from 'react-router';

const ClassificationsLayout = () => {
  return <ProtectedRoute component={Outlet} policies={['isAnyArtiaUser']}/>;
};

export default ClassificationsLayout;
